<template>
  <div class="instructions">
    <div class="stepper instructions">
      <div class="step">
        <p class="step-number"></p>
        <p class="step-title">{{ $t("Share with") }}</p>
        <p>
          {{ $t("Just use the native") }} <b>{{ $t("Share with") }}</b>
          {{ $t("functionality in any app, and select") }} <b>Mail2Self</b>
        </p>
      </div>
      <div class="step">
        <p class="step-number"></p>
        <p class="step-title">{{ $t("Enjoy hands-free") }}</p>
        <p>
          {{
            $t(
              "You will get the shared text or link as an email with no more clicks or taps!"
            )
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import InstallPWA from "@/components/InstallPWA.vue";
import Instructions from "@/components/Instructions.vue";

export default {
  name: "Instructions",

  components: {},

  data() {
    return {};
  },

  computed: {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.instructions {
  margin-left: auto;
  margin-right: auto;
  width: 75%;
}

@media (min-width: 961px) {
  .instructions {
    width: 50%;
  }
}
</style>
